/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EnergyCoefficient } from '../models/energy-coefficient';
import { getPerfEnergyKpIs$Any } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-any';
import { GetPerfEnergyKpIs$Any$Params } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-any';
import { getPerfEnergyKpIs$Json } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-json';
import { GetPerfEnergyKpIs$Json$Params } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-json';
import { getPerfEnergyKpIsGroupByStation$Any } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-group-by-station-any';
import { GetPerfEnergyKpIsGroupByStation$Any$Params } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-group-by-station-any';
import { getPerfEnergyKpIsGroupByStation$Json } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-group-by-station-json';
import { GetPerfEnergyKpIsGroupByStation$Json$Params } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-group-by-station-json';
import { getPerfEnergyKpIsPerStation } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-per-station';
import { GetPerfEnergyKpIsPerStation$Params } from '../fn/kpi-perf-energy/get-perf-energy-kp-is-per-station';
import { getPerfEnergyTimeSeries$Any } from '../fn/kpi-perf-energy/get-perf-energy-time-series-any';
import { GetPerfEnergyTimeSeries$Any$Params } from '../fn/kpi-perf-energy/get-perf-energy-time-series-any';
import { getPerfEnergyTimeSeries$Json } from '../fn/kpi-perf-energy/get-perf-energy-time-series-json';
import { GetPerfEnergyTimeSeries$Json$Params } from '../fn/kpi-perf-energy/get-perf-energy-time-series-json';
import { getPerfEnergyTimeSeriesPerStation } from '../fn/kpi-perf-energy/get-perf-energy-time-series-per-station';
import { GetPerfEnergyTimeSeriesPerStation$Params } from '../fn/kpi-perf-energy/get-perf-energy-time-series-per-station';
import { getPerfEnergyTimeSeriesStation$Any } from '../fn/kpi-perf-energy/get-perf-energy-time-series-station-any';
import { GetPerfEnergyTimeSeriesStation$Any$Params } from '../fn/kpi-perf-energy/get-perf-energy-time-series-station-any';
import { getPerfEnergyTimeSeriesStation$Json } from '../fn/kpi-perf-energy/get-perf-energy-time-series-station-json';
import { GetPerfEnergyTimeSeriesStation$Json$Params } from '../fn/kpi-perf-energy/get-perf-energy-time-series-station-json';
import { getStationEnergyCoefficient } from '../fn/kpi-perf-energy/get-station-energy-coefficient';
import { GetStationEnergyCoefficient$Params } from '../fn/kpi-perf-energy/get-station-energy-coefficient';
import { PerfEnergyKpiPeriod } from '../models/perf-energy-kpi-period';
import { PerfEnergyStationKpiPagedList } from '../models/perf-energy-station-kpi-paged-list';
import { PerfEnergyTimeSeries } from '../models/perf-energy-time-series';
import { PerfEnergyTimeSeriesStationPagedList } from '../models/perf-energy-time-series-station-paged-list';
import { upsertStationEnergyCoefficient } from '../fn/kpi-perf-energy/upsert-station-energy-coefficient';
import { UpsertStationEnergyCoefficient$Params } from '../fn/kpi-perf-energy/upsert-station-energy-coefficient';


/**
 * All about KPI Perf Energy
 */
@Injectable({ providedIn: 'root' })
export class KpiPerfEnergyService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPerfEnergyKpIs()` */
  static readonly GetPerfEnergyKpIsPath = '/custom/kpi/perf-energy';

  /**
   * Return a list of KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyKpIs$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPerfEnergyKpIs$Json$Response(params?: GetPerfEnergyKpIs$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PerfEnergyKpiPeriod>>> {
    return getPerfEnergyKpIs$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a list of KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyKpIs$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPerfEnergyKpIs$Json(params?: GetPerfEnergyKpIs$Json$Params, context?: HttpContext): Observable<Array<PerfEnergyKpiPeriod>> {
    return this.getPerfEnergyKpIs$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PerfEnergyKpiPeriod>>): Array<PerfEnergyKpiPeriod> => r.body)
    );
  }

  /**
   * Return a list of KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyKpIs$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPerfEnergyKpIs$Any$Response(params?: GetPerfEnergyKpIs$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PerfEnergyKpiPeriod>>> {
    return getPerfEnergyKpIs$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a list of KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyKpIs$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPerfEnergyKpIs$Any(params?: GetPerfEnergyKpIs$Any$Params, context?: HttpContext): Observable<Array<PerfEnergyKpiPeriod>> {
    return this.getPerfEnergyKpIs$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PerfEnergyKpiPeriod>>): Array<PerfEnergyKpiPeriod> => r.body)
    );
  }

  /** Path part for operation `getPerfEnergyKpIsPerStation()` */
  static readonly GetPerfEnergyKpIsPerStationPath = '/custom/kpi/perf-energy/station/{uid}';

  /**
   * Return a list of KPI, from a specific station, concerned by Energy Performance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyKpIsPerStation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerfEnergyKpIsPerStation$Response(params: GetPerfEnergyKpIsPerStation$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyKpiPeriod>> {
    return getPerfEnergyKpIsPerStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a list of KPI, from a specific station, concerned by Energy Performance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyKpIsPerStation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerfEnergyKpIsPerStation(params: GetPerfEnergyKpIsPerStation$Params, context?: HttpContext): Observable<PerfEnergyKpiPeriod> {
    return this.getPerfEnergyKpIsPerStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerfEnergyKpiPeriod>): PerfEnergyKpiPeriod => r.body)
    );
  }

  /** Path part for operation `getPerfEnergyKpIsGroupByStation()` */
  static readonly GetPerfEnergyKpIsGroupByStationPath = '/custom/kpi/perf-energy/group-by-station/search';

  /**
   * Return a list of station, with its KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyKpIsGroupByStation$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPerfEnergyKpIsGroupByStation$Json$Response(params?: GetPerfEnergyKpIsGroupByStation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyStationKpiPagedList>> {
    return getPerfEnergyKpIsGroupByStation$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a list of station, with its KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyKpIsGroupByStation$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPerfEnergyKpIsGroupByStation$Json(params?: GetPerfEnergyKpIsGroupByStation$Json$Params, context?: HttpContext): Observable<PerfEnergyStationKpiPagedList> {
    return this.getPerfEnergyKpIsGroupByStation$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerfEnergyStationKpiPagedList>): PerfEnergyStationKpiPagedList => r.body)
    );
  }

  /**
   * Return a list of station, with its KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyKpIsGroupByStation$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPerfEnergyKpIsGroupByStation$Any$Response(params?: GetPerfEnergyKpIsGroupByStation$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyStationKpiPagedList>> {
    return getPerfEnergyKpIsGroupByStation$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a list of station, with its KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyKpIsGroupByStation$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPerfEnergyKpIsGroupByStation$Any(params?: GetPerfEnergyKpIsGroupByStation$Any$Params, context?: HttpContext): Observable<PerfEnergyStationKpiPagedList> {
    return this.getPerfEnergyKpIsGroupByStation$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerfEnergyStationKpiPagedList>): PerfEnergyStationKpiPagedList => r.body)
    );
  }

  /** Path part for operation `getPerfEnergyTimeSeriesStation()` */
  static readonly GetPerfEnergyTimeSeriesStationPath = '/custom/time-series/perf-energy/{kpiType}/group-by-station';

  /**
   * Return a time series list, paginated, of a specific KPI, concerned by Energy Performance, group by station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyTimeSeriesStation$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPerfEnergyTimeSeriesStation$Json$Response(params: GetPerfEnergyTimeSeriesStation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyTimeSeriesStationPagedList>> {
    return getPerfEnergyTimeSeriesStation$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a time series list, paginated, of a specific KPI, concerned by Energy Performance, group by station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyTimeSeriesStation$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPerfEnergyTimeSeriesStation$Json(params: GetPerfEnergyTimeSeriesStation$Json$Params, context?: HttpContext): Observable<PerfEnergyTimeSeriesStationPagedList> {
    return this.getPerfEnergyTimeSeriesStation$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerfEnergyTimeSeriesStationPagedList>): PerfEnergyTimeSeriesStationPagedList => r.body)
    );
  }

  /**
   * Return a time series list, paginated, of a specific KPI, concerned by Energy Performance, group by station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyTimeSeriesStation$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPerfEnergyTimeSeriesStation$Any$Response(params: GetPerfEnergyTimeSeriesStation$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyTimeSeriesStationPagedList>> {
    return getPerfEnergyTimeSeriesStation$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a time series list, paginated, of a specific KPI, concerned by Energy Performance, group by station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyTimeSeriesStation$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPerfEnergyTimeSeriesStation$Any(params: GetPerfEnergyTimeSeriesStation$Any$Params, context?: HttpContext): Observable<PerfEnergyTimeSeriesStationPagedList> {
    return this.getPerfEnergyTimeSeriesStation$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerfEnergyTimeSeriesStationPagedList>): PerfEnergyTimeSeriesStationPagedList => r.body)
    );
  }

  /** Path part for operation `getPerfEnergyTimeSeries()` */
  static readonly GetPerfEnergyTimeSeriesPath = '/custom/time-series/perf-energy/{kpiType}';

  /**
   * Return a time series of a specific KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyTimeSeries$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPerfEnergyTimeSeries$Json$Response(params: GetPerfEnergyTimeSeries$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyTimeSeries>> {
    return getPerfEnergyTimeSeries$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a time series of a specific KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyTimeSeries$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPerfEnergyTimeSeries$Json(params: GetPerfEnergyTimeSeries$Json$Params, context?: HttpContext): Observable<PerfEnergyTimeSeries> {
    return this.getPerfEnergyTimeSeries$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerfEnergyTimeSeries>): PerfEnergyTimeSeries => r.body)
    );
  }

  /**
   * Return a time series of a specific KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyTimeSeries$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPerfEnergyTimeSeries$Any$Response(params: GetPerfEnergyTimeSeries$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyTimeSeries>> {
    return getPerfEnergyTimeSeries$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a time series of a specific KPI, concerned by Energy Performance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyTimeSeries$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPerfEnergyTimeSeries$Any(params: GetPerfEnergyTimeSeries$Any$Params, context?: HttpContext): Observable<PerfEnergyTimeSeries> {
    return this.getPerfEnergyTimeSeries$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerfEnergyTimeSeries>): PerfEnergyTimeSeries => r.body)
    );
  }

  /** Path part for operation `getPerfEnergyTimeSeriesPerStation()` */
  static readonly GetPerfEnergyTimeSeriesPerStationPath = '/custom/time-series/perf-energy/{kpiType}/station/{uid}';

  /**
   * Return a time series of a specific KPI, from a specifi station, concerned by Energy Performance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerfEnergyTimeSeriesPerStation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerfEnergyTimeSeriesPerStation$Response(params: GetPerfEnergyTimeSeriesPerStation$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyTimeSeries>> {
    return getPerfEnergyTimeSeriesPerStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a time series of a specific KPI, from a specifi station, concerned by Energy Performance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerfEnergyTimeSeriesPerStation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerfEnergyTimeSeriesPerStation(params: GetPerfEnergyTimeSeriesPerStation$Params, context?: HttpContext): Observable<PerfEnergyTimeSeries> {
    return this.getPerfEnergyTimeSeriesPerStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerfEnergyTimeSeries>): PerfEnergyTimeSeries => r.body)
    );
  }

  /** Path part for operation `upsertStationEnergyCoefficient()` */
  static readonly UpsertStationEnergyCoefficientPath = '/custom/perf-energy/stations/{uid}/coefficient/upsert';

  /**
   * Allow to upsert a station energy normalization coefficient.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertStationEnergyCoefficient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertStationEnergyCoefficient$Response(params: UpsertStationEnergyCoefficient$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return upsertStationEnergyCoefficient(this.http, this.rootUrl, params, context);
  }

  /**
   * Allow to upsert a station energy normalization coefficient.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertStationEnergyCoefficient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertStationEnergyCoefficient(params: UpsertStationEnergyCoefficient$Params, context?: HttpContext): Observable<void> {
    return this.upsertStationEnergyCoefficient$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStationEnergyCoefficient()` */
  static readonly GetStationEnergyCoefficientPath = '/custom/perf-energy/stations/{uid}/coefficient';

  /**
   * Get a station nergy normalization coefficient.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationEnergyCoefficient()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationEnergyCoefficient$Response(params: GetStationEnergyCoefficient$Params, context?: HttpContext): Observable<StrictHttpResponse<EnergyCoefficient>> {
    return getStationEnergyCoefficient(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station nergy normalization coefficient.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationEnergyCoefficient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationEnergyCoefficient(params: GetStationEnergyCoefficient$Params, context?: HttpContext): Observable<EnergyCoefficient> {
    return this.getStationEnergyCoefficient$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnergyCoefficient>): EnergyCoefficient => r.body)
    );
  }

}
